import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/userActions';
import * as events from '../constants/eventActions';

const userActions = {

    changeWeeklyQuota (userID, quota) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .post(env.tashi + '/users/' + userID + '/changeQuota')
                .query({
                    quota: quota
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.changeWeeklyQuota({ status: "failure", data: err }));
                    }

                    if (res.ok) {
                        let data = {id: userID, quota: quota};
                        dispatch(actions.changeWeeklyQuota({ status: "success", data: data }));
                    } else {
                        dispatch(actions.changeWeeklyQuota({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    cmlmLoadUsersForStaffOverview (week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/cmlmLoadForStaffOverview')
                .query({
                    week: week
                })
                .accept('application/JSON')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.cmlmLoadUsersForStaffOverview({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.cmlmLoadUsersForStaffOverview({ status: "success", data: data }));
                    } else {
                        dispatch(actions.cmlmLoadUsersForStaffOverview({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadAllForUsersOverview() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/findAllForUsersOverview')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if(err) {
                        dispatch(actions.loadAllForUsersOverview({status: "failure", data: err}));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if(data) {
                        dispatch(actions.loadAllForUsersOverview({ status: "success", data: data}));
                    } else {
                        dispatch(actions.loadAllForUsersOverview({ status: "success", data: []}));
                    }
                });
        };
    },

    loadAllUsers () {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadAllUsers({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.users;

                    if (data) {
                        dispatch(actions.loadAllUsers({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadAllUsers({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadCurrentUser() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/search/getCurrentUser')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadCurrentUser({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        let data = JSON.parse(res.text);

                        if (data) {
                            dispatch(actions.loadCurrentUser({ status: "success", data: data }));
                        } else {
                            dispatch(actions.loadCurrentUser({ status: "failure", data: res.status }));
                        }
                    }
                });
        };
    },

    loadPms () {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/search/findPms')
                .accept('application/JSON')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadPms({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded;

                    if (data) {
                        dispatch(actions.loadPms({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadPms({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadRegularUsers () {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/search/findUsers')
                .accept('application/JSON')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadRegularUsers({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.users;

                    if (data) {
                        dispatch(actions.loadRegularUsers({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadRegularUsers({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadSponsors () {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/search/findSponsors')
                .accept('application/JSON')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadSponsors({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.users;

                    if (data) {
                        dispatch(actions.loadSponsors({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadSponsors({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadUserByID (userID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/' + userID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUserByID({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadUserByID({ status: "success", data: data }));
                    }
                });
        };
    },

    loadUsersByTask (taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/users/search/findByTask?task=' + taskID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUsersByTask({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.users;

                    if (data) {
                        dispatch(actions.loadUsersByTask({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadUsersByTask({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadUsersNoLongerAssigned (taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserState());

            request
                .get(env.tashi + '/userTasks/' + taskID + '/noLongerAssigned')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUsersNoLongerAssigned({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadUsersNoLongerAssigned({ status: "success", data: data }));
                    }
                });
        };
    },

    setSelectedUser(user) {
        return dispatch => dispatch(actions.setSelectedUser(user));
    },

    setNotificationDelegate (userId, delegateId) {
        return dispatch => {
            request
                .post(env.tashi + '/users/' + userId + '/setNotificationDelegate')
                .query({ delegateId: delegateId })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        if (err.status === 400) {
                            dispatch(events.pushErrorEvent({ data: "set notification delegate - invalid delegate" }));
                        } else if (err.status === 404) {
                            dispatch(events.pushErrorEvent({ data: "set notification delegate - user not found" }));
                        } else {
                            dispatch(events.pushErrorEvent({ data: "set notification delegate" }));
                        }
                        return;
                    }

                    if (res.ok) {
                        dispatch(events.pushSuccessEvent({ data: "set notification delegate" }));
                        dispatch(userActions.loadUserByID(userId));
                    } else {
                        dispatch(events.pushErrorEvent({ data: "set notification delegate" }));
                    }
                });
        };
    },

    clearNotificationDelegate (userId) {
        return dispatch => {
            request
                .post(env.tashi + '/users/' + userId + '/clearNotificationDelegate')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(events.pushErrorEvent({ data: "clear notification delegate" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(events.pushSuccessEvent({ data: "clear notification delegate" }));
                        dispatch(userActions.loadUserByID(userId));
                    } else {
                        dispatch(events.pushErrorEvent({ data: "clear notification delegate" }));
                    }
                });
        };
    },

    syncUsersWithLDAP () {
        return dispatch => {
            dispatch(actions.syncUsersWithLDAP({ status: "starting" }));

            request
                .post(env.tashi + '/users/ldap/sync')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.syncUsersWithLDAP({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "sync users with LDAP" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.syncUsersWithLDAP({ status: "success" }));
                        dispatch(events.pushSuccessEvent({ data: "sync users with LDAP" }));
                    } else {
                        dispatch(actions.syncUsersWithLDAP({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "sync users with LDAP" }));
                    }
                });
        };
    },

    syncUserIdsWithAkira () {
      return dispatch => {
        dispatch(actions.syncUserIdsWithAkira({ status: "starting" }));

        request
          .post(env.tashi + '/users/akira/sync')
          .withCredentials()
          .accept('application/json')
          .end((err, res) => {
            if (err) {
              dispatch(actions.syncUserIdsWithAkira({ status: "failure", data: err }));
              dispatch(events.pushErrorEvent({ data: "sync user ids with Akira" }));
              return;
            }

            if (res.ok) {
              dispatch(actions.syncUserIdsWithAkira({ status: "success" }));
              dispatch(events.pushSuccessEvent({ data: "sync user ids with Akira" }));
            } else {
              dispatch(actions.syncUserIdsWithAkira({ status: "failure", data: res.status }));
              dispatch(events.pushErrorEvent({ data: "sync user ids with Akira" }));
            }
          });
      };
    }

};

export default userActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/userActionCreators.js
 **/